import React, {useState, useEffect, act} from "react";
import SidebarAdmin from "../../partials/sidebarAdmin";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
// componente
import ZonaCargando from "../zonaCargando";

function Errores(){
    const navigate    = useNavigate();
    const routeParams = useParams();
    const location    = useLocation(); 
    let {username, pagina} = routeParams; // capturamos para paginación

    const [usuario, setUsuario]                      = useState(null);
    const [cargando, setCargando]                    = useState(false);
    const [siguientePagina, setSiguientePagina]      = useState(null);
    const [paginaAnterior, setPaginaAnterior]        = useState(null); 
    const [cantidadDePaginas, setCantidadDePaginas]  = useState(null);
    const [infoUsuarioLocal, setInfoLocal]           = useState({}); // Variables localstorage
    const [equipos, setEquipos]                      = useState([]);
    const [usuarios, setUsuarios]                    = useState([]);
    const [archivo, setArchivo]                      = useState(null); // imagen subida
    const [errores, setErrores]                      = useState(null);
    const urlVolver   = "/admin/usuarios/" + routeParams.username + "/1";
    

    useEffect(() => {
    (async () => {
      try {
        setCargando(true);
        
        const verifToken = axios.get("/verificar-token", { withCredentials: true });
        const pErrores   = await axios.post("/obtener-errores");


        const [ resVerif, resErrores ] = await Promise.all([verifToken, pErrores ]);
        if(!resVerif.data.usuario){ return navigate("/alerta", {state: {titulo:"No estás autenticado", mensaje:"No estás autenticado, por favor inicia sesión.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        if(resVerif.data.usuario.tipo !== "Administrador"){ cerrarSesion(); return navigate("/alerta", {state: {titulo:"No eres administrador", mensaje:"No eres administrador.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
        setUsuario(resVerif.data.usuario);
        // errores
        setErrores(resErrores.data.errores); 
      } 
      catch (err) { console.error("Error en una de las solicitudes:", err); } 
      finally { setCargando(false);}
    })();
    }, []);



    async function cerrarSesion(event) {
        localStorage.clear(); // Limpiamos el almacenamiento local.
        const resCerrar = await axios.post("/logout");
    }



    async function finalizarError(datos) {
        
        const idError = datos.idError;
        
        try{
            await axios.post("/eliminar-error", {
                params: {idError}
            }).then(async function(response){
                alert("Error terminado.");
                window.location.reload();
            });
        }
        catch(err){
            alert("Error al terminar proceso. Vuelve a intentar");
        }
    }

    return(
    <div>
    {cargando ? <ZonaCargando /> : 
    <div className='contenedorPaginasUsuario'>
        <div className='contenedorSidebarYcontenido d-flex flex-row '>
            {/* BARRA LATERAL */}
            <SidebarAdmin />


            {/* Columna 2 */}
            <div className="flex-grow-1 container-fluid">
                
                {/* Contenedor título  */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-light">
                    <h1 className="h2 text-light">Ver errores</h1>
                </div>
        

                {/* Equipos existentes */}
                <div className="p-5 mb-4 contenedorOscuro rounded-3">
                    <div className=" my-5">
                        <h3 style={{textAlign: "center"}}>Errores</h3>
                        <p  style={{textAlign: "center"}}>En esta sección puedes ver los errores generados de la aplicación.</p>


                        { (errores)
                        ? errores.map( (actual, key) => (
                            <div key={actual.idError} className="row gx-3 gy-2 align-items-center mb-1 py-3">

                                {/* id */}
                                <div className="col-sm-2">
                                    <div className="form-floating">
                                        <input type="text" id="floatingInputGrid" readOnly className="form-control" defaultValue={actual.idError}  />
                                        <label htmlFor="floatingInputGrid">id</label>
                                    </div>
                                </div>

                                {/* Fecha */}
                                <div className="col-sm-3">
                                    <div className="form-floating">
                                        <input type="text" id="floatingInputGrid" readOnly className="form-control" 
                                        defaultValue={new Date(actual.fecha).toLocaleString('es-ES', { day: '2-digit', month: 'long', year: 'numeric',hour: '2-digit', minute: '2-digit', })} />
                                        <label htmlFor="floatingInputGrid">Fecha</label>
                                    </div>
                                </div>

                            
                                {/* Usuario */}
                                <div className="col-sm-2">
                                    <div className="form-floating">
                                        <input type="text" id="floatingInputGrid" readOnly className="form-control" defaultValue={actual.usuario}  />
                                        <label htmlFor="floatingInputGrid">Usuario</label>
                                    </div>
                                </div>

                                {/* Dispositivo */}
                                <div className="col-sm-3">
                                    <div className="form-floating">
                                        <input type="text" id="floatingInputGrid" readOnly className="form-control" defaultValue={actual.dispositivo}  />
                                        <label htmlFor="floatingInputGrid">Dispositivo</label>
                                    </div>
                                </div>

                                {/* Botón cambio de imagen */}
                                <div className="col-sm-2">
                                    <button
                                    className="w-100 btn btn-warning"
                                    onClick={(event) => {
                                        const datosAdicionales = {
                                        idError: actual.idError
                                        };
                                        finalizarError(datosAdicionales);
                                    }}
                                    >
                                    Terminar
                                    </button>
                                </div>

                                {/* Error */}
                                <div className="col-sm-12">
                                    <div className="form-floating">
                                        <textarea
                                        id="floatingInputGrid"
                                        readOnly
                                        className="form-control"
                                        defaultValue={actual.error}
                                        style={{ height: '100px' }} // Ajusta la altura según lo necesites
                                        />
                                        <label htmlFor="floatingInputGrid">Error</label>
                                    </div>
                                </div>

                            </div>
                        ))
                        : <p>Aún cargando</p>
                        }

                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    </div>
    )
}

export default Errores;